import { Fragment } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import DeviceLookup from "./Device/DeviceLookup";
import VirtualIdBypassLookup from "./Device/VirtualIdBypassLookup";
import DomainLookup from "./Domain/DomainLookup";
import LocationLookup from "./Location/LocationLookup";
import ChargifyShopifyLookup from "./ChargifyShopifyLookup/ChargifyShopifyLookup";
import { useAuthDataContext } from "./AuthDataProvider";

export default function Dashboard() {
  const { user } = useAuthDataContext();
  
  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={6}>
          <h1>Device Lookup</h1>
          <Paper>
            <DeviceLookup />
          </Paper>
          <h1>Domain Lookup</h1>
          <Paper>
            <Grid container spacing={0}>
              <DomainLookup />
            </Grid>
          </Paper>
          <h1>Location Lookup</h1>
          <Paper>
            <LocationLookup />
          </Paper>
          <h1>Order Lookup</h1>
          <Paper>
            <ChargifyShopifyLookup />
          </Paper>
          {user && (user.roles.includes("firmware") || user.roles.includes("admin")) && (
            <>
              <h1>Virtual ID Bypass Lookup</h1>
              <Paper>
                <VirtualIdBypassLookup />
              </Paper>
            </>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}
